/**
 * There may be clients that won't want to populate meta_description,
 * and they may want to use complex HTML in the product description.
 * In that case, we'll need to provide a RegExp in the config and apply it on the output here.
 */
export const complexTextValueToString = (
    input?: string,
    regExp?: string | null,
    maxLength?: number | null
): string => {
    if (!input) {
        return ''
    }

    let output = input.replace(/(<style>[^>]+>)/gi, '') // Remove PageBuilder styles
    // Decode HTML entities
    if (typeof window !== 'object') {
        // eslint-disable-next-line @typescript-eslint/no-var-requires, @typescript-eslint/no-require-imports
        const he = require('he') // HTML Entity encoder/decoder for server side
        output = he.decode(output)
    } else {
        const tmpElement = document.createElement('p')
        tmpElement.innerHTML = output
        output = String(tmpElement.innerText)
    }
    output = output.replace(/(<([^>]+)>)/gi, '') // Remove HTML tags

    if (output && regExp) {
        try {
            output = output.replace(new RegExp(regExp), '')
        } catch (e) {
            console.log(e)
        }
    }

    output = output.replace(/[\r|\n]/gi, '').trim() // Remove New Line characters
    return maxLength && output.length >= maxLength
        ? `${output.substring(0, maxLength - 3)}...`
        : output
}
